'use strict';

var $ = require('jquery'),
  Backbone = require('backbone');

Backbone.$ = $;

var SecondaryNav = Backbone.View.extend({

  events: {
    'click .SecondaryNav-discover': 'toggleSecondaryNav'
  },

  toggleSecondaryNav: function(e) {
    e.preventDefault();
    this.$('.SecondaryNav-menu').toggleClass('SecondaryNav-menu--open');
    this.$('.Icon').toggleClass('is--inverted');
  }

});

module.exports = SecondaryNav;



// WEBPACK FOOTER //
// ./assets/js/navigation/SecondaryNav.js